export default {
  '13th August 2024': [
    'Added sentences to default categories, with a setting to switch between practicing words, sentences, or both',
    'Reduced the amount of numbers in the Digits category to balance them out in the Lucky Dip category',
    'Renamed the "built-in" categories to "default" categories',
  ],
  '25th June 2024': [
    'Added the Digits built-in category',
  ],
  '13th June 2024': [
    'Added more words to the built-in categories',
  ],
  '21st April 2024': [
    'Made page headers with controls stick to the top of the screen on large devices',
    'Moved controls to the bottom of the screen on mobile',
    'Made the New Category, Rename Category, and New Word buttons automatically focus their relevant text fields',
    'Added alphabetical sorting to the custom categories',
  ],
  '3rd April 2024': [
    'Changed the set of colours used for the category icons',
  ],
  '1st April 2024': [
    'Added support for numbers, making the keyboard adapt to each word as a regular keyboard (with or without a number row) or a dial-pad',
  ],
  '31st March 2024': [
    'Replaced the end-of-practice trophy icon with a medal animation',
  ],
  '25th March 2024': [
    'Added the Lucky Dip category with every built-in word',
    'Added this changelog',
  ],
  '14th March 2024': [
    'Added an exit practice button to the "next word" screen',
    'Replaced the hamburger icon menu button at the top of the screen on mobile with a button that says "Menu"',
  ],
  '5th January 2023': [
    'Added a 404 page to make it clear what went wrong when a URL is mistyped',
  ],
  '3rd November 2022': [
    'Improved small-screen layout to enable Project QWERTY to be used on mobile phones',
  ],
  '19th May 2022': [
    'Officially launched Project QWERTY!',
  ],
};
